var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("Card", {
        attrs: { title: "On Boarding Banner" },
        scopedSlots: _vm._u([
          {
            key: "body",
            fn: function() {
              return [
                _c(
                  "div",
                  { staticClass: "flex flex-col pb-5 border-b" },
                  [
                    _c(
                      "h5",
                      {
                        staticClass:
                          "text-gray-700 text-sm mt-3 mb-6 font-bold uppercase text-left"
                      },
                      [_vm._v("\n          Banner Form\n        ")]
                    ),
                    _vm._v(" "),
                    _c("form-item", {
                      attrs: { label: "Image" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function() {
                            return [
                              _c("input", {
                                staticClass:
                                  "block border border-grey-light w-full p-3 rounded mb-4",
                                attrs: {
                                  type: "file",
                                  name: "profile_picture",
                                  accept: "image/*"
                                },
                                on: { change: _vm.onFileChange }
                              }),
                              _vm._v(" "),
                              _c("div", { staticClass: "tooltip" }, [
                                _vm.input.file
                                  ? _c("img", {
                                      staticStyle: {
                                        width: "150px",
                                        margin: "0px auto"
                                      },
                                      attrs: { src: _vm.input.file },
                                      on: { click: _vm.changeImage }
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  { staticClass: "hint-tooltip" },
                                  [
                                    _c("font-awesome-icon", {
                                      attrs: {
                                        icon: ["fas", "times-circle"],
                                        size: "2x"
                                      },
                                      on: { click: _vm.changeImage }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("p", { staticClass: "text-xs text-left" }, [
                                  _vm._v(
                                    "Input 624 x 208 px image in JPG or PNG. Max image size 1MB"
                                  )
                                ])
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "flex flex-col pt-2" },
                                [
                                  _vm.$v.input.file.$dirty &&
                                  !_vm.$v.input.file.required
                                    ? _c("text-error", {
                                        attrs: {
                                          text: "Please select banner image."
                                        }
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.isFileLarge
                                    ? _c("text-error", {
                                        attrs: {
                                          text:
                                            "Please using image lower than 1MB."
                                        }
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.isFileWrongFormat
                                    ? _c("text-error", {
                                        attrs: {
                                          text:
                                            "Please use a valid image format"
                                        }
                                      })
                                    : _vm._e()
                                ],
                                1
                              )
                            ]
                          },
                          proxy: true
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "w-1/5" },
                      [
                        _c(
                          "Button",
                          {
                            staticClass: "w-full",
                            attrs: { variant: "primary", label: "Save" },
                            on: { clicked: _vm.submit }
                          },
                          [_vm._v("Save")]
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "flex flex-col py-3" }, [
                  _c(
                    "h5",
                    {
                      staticClass:
                        "text-gray-700 text-sm mt-3 font-bold uppercase text-left"
                    },
                    [_vm._v("\n          Banner List\n        ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "w-full p-3" },
                    [
                      _c(
                        "el-table",
                        {
                          staticStyle: { width: "100%" },
                          attrs: { data: _vm.list, "row-key": "id" }
                        },
                        [
                          _c("el-table-column", {
                            key: "cover",
                            attrs: { label: "Image", width: "650" },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "static inline-block text-center container-action"
                                      },
                                      [
                                        _c("img", {
                                          staticStyle: {
                                            width: "624px",
                                            height: "208px",
                                            "object-fit": "cover"
                                          },
                                          attrs: { src: scope.row.url }
                                        })
                                      ]
                                    )
                                  ]
                                }
                              }
                            ])
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: { label: "Actions", align: "right" },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "static inline-block text-left container-action"
                                      },
                                      [
                                        _c(
                                          "VueCustomTooltip",
                                          {
                                            attrs: {
                                              label: "Delete",
                                              position: "is-left"
                                            }
                                          },
                                          [
                                            _c(
                                              "button",
                                              {
                                                staticClass:
                                                  "p-2 mr-2 rounded bg-red-500 hover:bg-red-600 focus:outline-none",
                                                on: {
                                                  click: function($event) {
                                                    return _vm.deleteBanner(
                                                      scope.row
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _c("font-awesome-icon", {
                                                  staticClass: "text-white",
                                                  attrs: {
                                                    icon: ["fa", "trash-alt"]
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    )
                                  ]
                                }
                              }
                            ])
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ])
              ]
            },
            proxy: true
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5ef042c6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5ef042c6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/AppSetting/OnboardingBanner.vue
// module id = null
// module chunks = 